import { useEffect, useState, useCallback } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";

import fstyles from "./Forbiddenstyles.module.css"
import styles from "../../Dashboard/Dashboard.module.css"
import ofglogo from '../../../images/logo.png'


const Forbidden = ({ reloadApp }) => {
	return (
		<div className={styles.main_container}>

			<button className={fstyles.logoClock} onClick={() => reloadApp()}>
				<img src={ofglogo}/>
			</button>

			<div className={styles.page_container_cus}>
				<div className={fstyles.hover}>
				  <div className={fstyles.background}>
				    <div className={fstyles.door}><p className={fstyles.forbidden_1}>403</p><p className={styles.forbidden_text}>Access Denied</p></div>
				    <div className={fstyles.rug}></div>
				  </div>
				  <div className={fstyles.foreground}>
				    <div className={fstyles.bouncer}>
				      <div className={fstyles.head}>
				        <div className={fstyles.neck} />
				        <div className={`${fstyles.eye} ${fstyles.left}`} />
				        <div className={`${fstyles.eye} ${fstyles.right}`} />
				        <div className={fstyles.ear} />
				      </div>
				      <div className={fstyles.body} />
				      <div className={fstyles.arm} />
				    </div>
				    <div className={fstyles.poles}>
				      <div className={`${fstyles.pole} ${fstyles.left}`} />
				      <div className={`${fstyles.pole} ${fstyles.right}`} />
				      <div className={fstyles.rope} />
				    </div>
				  </div>
				</div>

			</div>
		</div>
	)
};

export default Forbidden;
